import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'scroll',
  'touchstart'
];

export const useIdleLogout = (timeout) => {
  const { logout, user } = useAuth();
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      console.warn('User inactive — logging out');
      logout();
    }, timeout);
  };

  useEffect(() => {
    if (!user) return;

    EVENTS.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer(); // start timer immediately

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      EVENTS.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
    };
  }, [user]);
};
